module.exports = __webpack_public_path__ + "static/img/point-icon-img@w.ab43c19.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ing-life/point-icon-img@w.png
// module id = UNPq
// module chunks = 0